import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { TourismEventsFiltersComponent } from '../tourism-events/tourism-events-filters/tourism-events-filters.component';

import { AuthService } from '../auth/auth.service';
import { Data2Service } from '../common/data2.service';
import { DateService } from '../common/date.service';

@Component({
	selector: 'app-dispatcher',
	templateUrl: './dispatcher.component.html',
	styleUrls: ['./dispatcher.component.css'],
})
export class DispatcherComponent implements OnInit {
	private itemsBeforeDataLoad = 8;
	loader = true;
	pageTitle = '';
	filters: any = {
		date_prepare_from: null,
		date_prepare_to: null,
		date_to_from: null,
		date_to_to: null,
	};
	data: Array<object>;
	vehicles: Array<any> = [];
	drivers: Array<any> = [];
	tableRows = [];
	parameters = {
		vehicle: [],
		category: [],
		status: [],
		yesno: [],
		vehicle_type: [],
		vehicle_busType: [],
		vehicle_category: [],
		vehicle_status: [],
		users: [],
		showDeleted: 0,
	};

	constructor(
		private readonly api: Data2Service,
		private readonly date: DateService,
		public auth: AuthService,
		private readonly route: ActivatedRoute,
	) {}

	ngOnInit(): void {
		this.route.params.subscribe((params) => {
			switch (params.side) {
				case 'departure':
					this.pageTitle = 'Odprawy';
					this.tableRows = [
						{ id: 'date_prepare', name: 'Data odprawy' },
						{ id: 'briefingPlace', name: 'Miejsce odprawy' },
						{ id: 'date_from', name: 'Data wyjazdu' },
						{ id: 'vehicleName', name: 'Autokar' },
						{ id: 'name', name: 'Docelowo' },
						{ id: 'driversDeparture', name: 'Kierowcy' },
						{ id: 'textBriefing', name: 'Uwagi' },
						{ id: 'briefingUserName', name: 'Koordynator' },
					];
					this.filters.date_prepare_from = this.date.daysAdd(-2);
					this.filters.date_prepare_to = this.date.daysAdd(+3);
					this.filters.date_to_from = null;
					this.filters.date_to_to = null;
					break;
				case 'return':
					this.pageTitle = 'Powroty';
					this.tableRows = [
						{ id: 'place_return', name: 'Miejsce powrotu' },
						{ id: 'date_to', name: 'Data powrotu' },
						{ id: 'vehicleName', name: 'Autokar' },
						{ id: 'name', name: 'Docelowo' },
						{ id: 'driversReturn', name: 'Kierowcy' },
					];
					this.filters.date_to_from = this.date.daysAdd(-2);
					this.filters.date_to_to = this.date.daysAdd(+3);
					this.filters.date_prepare_from = null;
					this.filters.date_prepare_to = null;
					break;
			}
			this.loadData();
		});
		this.api.get('/parameters/', (result, error) => {
			this.parameters.vehicle_type = this.api.typeParametersConvert(result.data, 1);
			this.parameters.vehicle_category = this.api.typeParametersConvert(result.data, 4);
			this.parameters.category = this.api.typeParametersConvert(result.data, 6);
			this.parameters.yesno = [
				{ id: 1, name: 'Tak' },
				{ id: 0, name: 'Nie' },
			];
			this.loadData();
		});
		this.api.get('/vehicles/', (result, error) => {
			this.vehicles = result.data;
			this.loadData();
		});
		this.api.get('/users/?status=1', (result, error) => {
			this.parameters.users = result.data;
			this.loadData();
		});
		this.api.get('/vehicleBusTypes/', (result, error) => {
			this.parameters.vehicle_busType = result.data;
			this.loadData();
		});
		this.api.get('/vehicleStatuses/', (result, error) => {
			this.parameters.vehicle_status = result.data;
			this.loadData();
		});
		this.api.get('/drivers/', (result, error) => {
			this.drivers = result.data;
			this.loadData();
		});
		this.api.get('/tourismEventsStatuses/', (result, error) => {
			this.parameters.status = result.data;
			this.loadData();
		});
	}

	private loadData() {
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.loader = true;
		this.filters.showDeleted = 0;
		const parms = this.api.getChecked(this.filters, this.parameters);
		this.api.get('/tourismEvents/?' + parms + '&datesBriefing=1', (result, error) => {
			result.data.forEach((obj) => {
				const briefingUser = this.parameters.users.find((user) => user.id == obj.briefingUser);
				obj.briefingUserName = briefingUser ? briefingUser.name : '';
				const vehicle = this.vehicles.find((vehicle) => vehicle.id == obj.vehicle);
				obj.vehicleName = vehicle ? vehicle.name : '?';
				obj.driversDeparture = obj.drivers_departure.length
					? this.driversParse(obj.drivers_departure)
					: this.driversParse(obj.drivers_program);
				obj.driversReturn = obj.drivers_return.length
					? this.driversParse(obj.drivers_return)
					: this.driversParse(obj.drivers_program);
			});
			result.data.sort((a, b) => {
				return new Date(a.date_from).getTime() / 1000 - new Date(b.date_from).getTime() / 1000;
			});
			this.data = result.data;
			this.loader = false;
		});
	}

	private driversParse(drivers: Array<any>) {
		const result = [];
		drivers.forEach((driver) => {
			const driverData = this.drivers.find((obj) => obj.id == driver.driver);
			if (!driverData) {
				return;
			}
			let phone = driverData.phone_business ? driverData.phone_business : '';
			phone += driverData.phone_private ? ' ' + driverData.phone_private : '';
			if (phone) {
				phone = ' <small>(' + phone + ')</small>';
			}
			result.push(driverData.last_name + ' ' + driverData.first_name + phone);
		});
		return result.join('<br>');
	}

	/*public filtersOpen() {
    new TourismEventsFiltersComponent(this.api).filtersOpen();
  }*/

	filtersSelected(data) {}
}
